import React from 'react';
import { getContext } from 'common';
import Styled from './styles';

export interface FieldSetProps extends React.ComponentPropsWithRef<'div'> {
  /** The content of the FieldSet */
  children: React.ReactNode;
}

/** All props will be provided to the root element (`FieldSet` native element). To get the ref of the outermost element use `ref` prop. [Read React useRef hook documentation](https://reactjs.org/docs/hooks-reference. */
const FieldSet = React.forwardRef<HTMLElement, FieldSetProps>((props: FieldSetProps, ref) => getContext(({ RTL }) => {
  const {
    children,
    ...wrapperProps
  } = props;
  return (
    <Styled.FieldSet {...wrapperProps} ref={ref} RTL={RTL}>
      {children}
    </Styled.FieldSet>
  );
}));

FieldSet.displayName = 'FieldSet';

export default FieldSet;
